import { render, staticRenderFns } from "./cross.vue?vue&type=template&id=50382e73&scoped=true&"
var script = {}
import style0 from "./cross.vue?vue&type=style&index=0&id=50382e73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50382e73",
  null
  
)

export default component.exports